import React, { useState, useEffect } from 'react'
import { Table, Divider, Tooltip, Icon, InputNumber, message } from 'antd'
import { INSTALL_STATUS, INSTALL } from '@/constants/util'
import { uninstall, bindposition, unbindposition, setPro } from '@/api/business'
import { canPointBind } from '@/api/equipment'
import UninstallModal from './Modal'
import BindModal from './BindModal'
import UnBindModal from './UnBindModal'
import { useHistory } from 'react-router-dom'

const Content = (props) => {
  const history = useHistory()
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
    onUpdate = () => {},
    onRefresh = () => {},
    id,
  } = props

  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  const [uninstallVisible, setUninstallVisible] = useState(false)

  const [unbindVisible, setUnbindVisible] = useState(false)

  const [bindVisible, setBindVisible] = useState(false)

  const [current, setCurrent] = useState({})

  const [editingTryPointId, setEditingTryPointId] = useState(-1)

  const [editingPro, setEditingPro] = useState(0)

  const handleUninstall = (current) => {
    setUninstallVisible(true)
    setCurrent(current)
  }

  const handleUnbind = (current) => {
    setUnbindVisible(true)
    setCurrent(current)
  }

  const requestCanPointBind = () => {
    canPointBind({
      companyId: id,
    }).then((res) => {
      if (res.success) {
        setEquipment(
          res.data.map((item) => ({
            label: item.capsuleNo,
            value: item.capsuleId,
          }))
        )
      }
    })
  }

  const handleBind = (current) => {
    requestCanPointBind()
    setBindVisible(true)
    setCurrent(current)
  }
  const [equipment, setEquipment] = useState([])

  useEffect(() => {
    requestCanPointBind()
  }, [])
  const setQuestion = (record) => {
    // sessionStorage.setItem(
    //   'questionTitle',
    //   (record.brandName ? record.brandName : '') + record.name + '调查问卷'
    // )
    if (!record.capsuleId) {
      message.error('请先绑定设备')
      return
    }
    localStorage.setItem('goodsPageInfo', JSON.stringify(page))
    history.push('/page/business/question/' + record.capsuleId)
  }
  const renderAction = (record) => {
    let arr = [<a onClick={() => setQuestion(record)}>设置问卷</a>]
    if (record.capsuleNo) {
      if (record.status === INSTALL) {
        arr.push(
          <Tooltip title='需要先解除安装，才能解绑设备'>
            <a href='#' onClick={() => onUpdate(record)}>
              解除绑定
            </a>
          </Tooltip>
        )
      } else {
        arr.push(
          <a href='#' onClick={() => handleUnbind(record)}>
            解除绑定
          </a>
        )
      }
    } else {
      arr.push(
        <a href='#' onClick={() => handleBind(record)}>
          绑定设备
        </a>
      )
    }
    if (record.status === INSTALL) {
      arr.push(
        <a href='#' onClick={() => handleUninstall(record)}>
          解除安装
        </a>
      )
    }
    let newArr = []

    arr.forEach((item, index) => {
      newArr.push(item)
      if (arr.length != index + 1) {
        newArr.push(<Divider type='vertical' />)
      }
    })
    return newArr
  }

  const handleCancelUninstall = () => {
    setUninstallVisible(false)
    setCurrent({})
  }

  const handleCancelUnbind = () => {
    setUnbindVisible(false)
    setCurrent({})
  }

  const handleConfirmUninstall = () => {
    uninstall(current.capsuleId).then((res) => {
      if (res.success) {
        message.success('设备解除安装成功！')
        setCurrent({})
        setUninstallVisible(false)
        onRefresh()
      }
    })
  }

  const handleConfirmUnbind = () => {
    unbindposition(current.tryPointId).then((res) => {
      if (res.success) {
        message.success('设备解除安装成功！')
        setCurrent({})
        setUnbindVisible(false)
        onRefresh()
      }
    })
  }

  const handleDoubleClick = (record) => {
    setEditingTryPointId(record.tryPointId)
    setEditingPro(record.proportion)
  }

  const handleChangePro = (value) => {
    setEditingPro(value)
  }

  const handleBlur = () => {
    setPro({
      tryPointId: editingTryPointId,
      proportion: editingPro,
    }).then((res) => {
      if (res.success) {
        setEditingPro(0)
        setEditingTryPointId(-1)
        setCurrent({})
        onRefresh()
      }
    })
  }
  const viewPosition = (value) => {
    history.push('/page/business/details/' + value.tryPointId)
  }
  const columns = [
    {
      title: '投放点位',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '设备编号',
      dataIndex: 'capsuleNo',
      key: 'capsuleNo',
    },
    {
      title: '安装状态',
      dataIndex: 'status',
      key: 'status',
      render: (text) => {
        return INSTALL_STATUS[text]
      },
    },
    {
      title: () => {
        return (
          <div>
            <span>分账比例</span>
            <Tooltip title={'即点位可获得的分账比例'}>
              <Icon
                type='question-circle'
                theme='filled'
                style={{ color: 'rgba(245, 166, 35, 1)' }}
              />
            </Tooltip>
          </div>
        )
      },
      dataIndex: 'proportion',
      key: 'proportion',
      render: (text, record) => {
        return record.tryPointId === editingTryPointId ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <InputNumber
              style={{ width: 80 }}
              value={editingPro}
              onChange={handleChangePro}
              onBlur={handleBlur}
            />
            <div>%</div>
          </div>
        ) : (
          <div
            onDoubleClick={() => handleDoubleClick(record)}>{`${text} %`}</div>
        )
      },
    },
    {
      title: '投放品牌商',
      dataIndex: 'brandNum',
      key: 'brandNum',
      render: (text, record) => {
        return text ? (
          <a href={`/page/business/business/brand/${record.tryPointId}`}>
            {text}
          </a>
        ) : (
          text
        )
      },
    },
    {
      title: '投放商品',
      dataIndex: 'viewPosition',
      key: 'viewPosition',
      render: (text, record) => {
        return <a onClick={() => viewPosition(record)}>查看详情</a>
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return renderAction(record)
      },
    },
  ]

  const handleBindPosition = (values) => {
    bindposition({
      ...values,
      tryPointId: current.tryPointId,
    }).then((res) => {
      if (res.success) {
        message.success('绑定设备成功！')
        setCurrent({})
        setBindVisible(false)
        onRefresh()
      }
    })
  }

  const handleCancelBindPosition = () => {
    setBindVisible(false)
    setCurrent({})
  }

  return (
    <div className='bg-white pt-16 pr-24 pl-24'>
      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey='tryPointId'
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ['10', '20', '30', '40'],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />

      <UninstallModal
        visible={uninstallVisible}
        onCancel={handleCancelUninstall}
        onConfirm={handleConfirmUninstall}
      />

      <UnBindModal
        visible={unbindVisible}
        onCancel={handleCancelUnbind}
        onConfirm={handleConfirmUnbind}
      />

      <BindModal
        visible={bindVisible}
        current={current}
        equipment={equipment}
        onUpdate={handleBindPosition}
        onCancel={handleCancelBindPosition}
      />
    </div>
  )
}

export default Content
